<template>
  <div class="voyage-card">
    <div
      class="bg"
      :style="{ backgroundImage: 'url(' + voyage.thumbnail[0] + ')' }"
    ></div>

    <div class="inner d-flex justify-content-between flex-column">
      <div>
        <span class="tag-link tag-link-white destination">{{
          voyage.destination_name
        }}</span>

        <span class="tag-link type">{{ voyage.type_texte }}</span>

        <h4 class="titre text-white mt-3" v-html="voyage.title.rendered"></h4>
      </div>

      <span v-if="voyage.template == 1" class="duree"
        >{{ voyage.nb_jours }} jours - {{ voyage.nb_nuits }} nuits</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "VoyageCard",

  props: {
    voyage: {
      type: Object,
      default: null
    }
  }
};
</script>
